<template>
  <ViewCustomData v-if="sourceId" entityName="source_param" entitySpec="data" serviceName="BaseService"
    :columns="SOURCE_PARAM_COLUMNS" scrollHeight="400px" :paginator="false" ref="viewSourceParamData"
    :masterDetail="{ source_id: sourceId }" :visibleButtons="{ delete: false }" />
</template>

<script setup>
import { SOURCE_PARAM_COLUMNS } from './sourceConstants.js'
import { defineProps } from 'vue'

const props = defineProps({
  sourceId: {
    type: [Number, String],
    default: null
  }
})
</script>

<style lang="scss" scoped>
:deep(.p-treetable .p-treetable-tbody > tr > td) {
  padding: 0.2rem 0.2rem !important;
}
</style>